import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { clearState, updateOrder } from 'src/slices/order';
import Button from '../atoms/Button';
import InputWrap from '../molecules/InputWrap';
import css from './CancelOrderModal.module.scss';
import GlobalModal from './GlobalModal';
import Note from '../atoms/Note';

export default function CancelOrderModal({ closeFunction, selectedOrder }) {
  const dispatch = useDispatch();
  const [reason, setReason] = useState();
  const { status } = useSelector((state) => state.order);

  const cancelOrder = () => {
    const data = {
      status: 'cancelled',
      reason: reason || 'none',
      orderId: selectedOrder._id,
    };
    dispatch(updateOrder(data));
  };

  useEffect(() => {
    if (status.updateOrder.isLoading) {
      toast.info('Cancelling order...');
    }
    if (status.updateOrder.isSuccess) {
      toast.success('Order cancelled!');
      dispatch(clearState(status.updateOrder));
      closeFunction();
    }
    if (status.updateOrder.isError) {
      toast.error('Order could not be cancelled. Please try again.');
      dispatch(clearState(status.updateOrder));
    }
  }, [status.updateOrder]);

  return (
    <GlobalModal
      title="Cancel Order"
      closeFunction={closeFunction}
      buttons={
        <>
          <Button label="Cancel Order" color="error" variant='tertiary' action={cancelOrder} />
          <Button label="Keep Order" color="emerald" action={closeFunction} />
        </>
      }
    >
      <div className={css['content']}>
        <p>Are you sure want to cancel Order #{selectedOrder.orderRef}?</p>

        <Note
          color="red"
          icon="fad fa-exclamation-triangle"
          text="
            This action cannot be reverted."
          
        />
        <InputWrap
          label="reason"
          component={<textarea value={reason} onChange={(e) => setReason(e.target.value)} />}
          helpText="This will be shown the customer"
        />
      </div>
    </GlobalModal>
  );
}
